import { render } from "./DialogGeneralPuchaseWarning.vue?vue&type=template&id=1e2be130&scoped=true"
import script from "./DialogGeneralPuchaseWarning.vue?vue&type=script&lang=js"
export * from "./DialogGeneralPuchaseWarning.vue?vue&type=script&lang=js"

import "./DialogGeneralPuchaseWarning.vue?vue&type=style&index=0&id=1e2be130&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1e2be130"

export default script